import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterLoanAgrEvPageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='loan_agreement_ev'
        title='EV terms'
        activeTab='loanAgreement'
        navConfig={{ loanAgrPage: 'loanSpecific', subNavType: 'loanSpecific', subNavPage: 'ev' }}
      />
    )
  }
}

export default MasterLoanAgrEvPageSF
